import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import { JourneyListPage } from './journey-list'

const journeyRoutes: Route[] = [
  {
    path: Paths.JOURNEY_LIST_PAGE,
    element: <JourneyListPage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default journeyRoutes
